<ng-container *ngFor="let alert of alertNotifications">
  <div class="alert alert-{{ alert.type.toString().toLowerCase() }}" role="alert" style="z-index: 99999 !important;">{{ alert.message }}</div>
</ng-container>
